import { Component, input } from '@angular/core';
import { translations } from '@app/utils/translations';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'auth-header',
    imports: [TranslatePipe],
    template: `
        <img class="kone-logo" src="assets/images/kone-logo-blue.png" alt="kone" />

        <div class="text-3xl flex flex-col mt-item">
            <div>{{ translations.auth.welcome | translate }}</div>
            <div>{{ translations.title | translate }}</div>
        </div>

        @if (hint()) {
            <div class="mt-item">{{ hint()! | translate }}</div>
        }
    `,
    styles: `
        :host {
        }
    `,
})
export class AuthHeaderComponent {
    protected readonly translations = translations;

    hint = input<string>();
}
